<template>
  <div>
    <!--  聊天工具设置 -->
    <el-dialog :title="$t('message.chatToolSettings')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="488px" center>
      <div class="content">
        <div class="key">
          <el-radio v-model="detail.chat" :label="1">rakuchat</el-radio>
        </div>
        <div class="key">
          <el-radio v-model="detail.chat" :label="2">chatwork</el-radio>
          <el-input v-if="detail.chat == 2" v-model="detail.chatwork" placeholder="请输入群组ID"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,
      chat: "",
    };
  },
  computed: {},
  methods: {
    // 保存
    save() {
      let datas = {
        user_id: this.$route.query.userID,
        chatwork: this.detail.chat == 1 ? "0" : this.detail.chatwork,
      };
      this.$api.clienteleApi.setClientChatType(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.clientDetail();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .key {
    display: flex;

    text-align: center;
    margin-bottom: 20px;

    /deep/.el-radio {
      line-height: 40px;
    }
  }

  .val {
    flex: 3;
  }
}

/deep/.el-radio__input {
  transform: scale(1.5) !important;
}
</style>